export function removeCurrencyCode(price?: string) {
  return price?.replace(/ [A-Z]{3}$/, '');
}
